import { Injectable } from '@angular/core';
import { Account } from '@qvs/core';
import { Observable, of } from 'rxjs';
import { hasCrmRole } from '@qvs/core/user';
import { switchMap, takeWhile, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as wizeMobileApi from '@wize-mobile-api';
import { AccountMapper } from '~/modules/accounts/account.mapper';
import { selectIsAuthenticated } from '@qvs/core/auth';
import { loadAccounts } from '~/modules/accounts/slice/account.actions';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  constructor(
    private readonly store: Store,
    private readonly accountApi: wizeMobileApi.AccountMobileService
  ) {}

  loadAccounts = (): Observable<Account[]> =>
    this.accountApi.listAccounts().pipe(switchMap((accounts) => of(AccountMapper.fromWizeAccounts(accounts))));

  public init = (): Promise<void> => {
    this.store
      .select(selectIsAuthenticated)
      .pipe(
        withLatestFrom(this.store.select(hasCrmRole)),
        takeWhile(([isAuthenticated, isCrm]) => isAuthenticated && !isCrm)
      )
      .subscribe(() => this.store.dispatch(loadAccounts()));
    return Promise.resolve();
  };
}
